import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    tarjetaId: 0,
    tarjetaResumenId: 0,

    banco: '',
    tarjetaMarca: '',
    numeroCuenta: '',
    fechaCierre: '1900-01-01',
    fechaVencimiento: '1900-01-01',
    totalPlasticosPesos: 0,
    totalPlasticosDolares: 0,
    plasticos: [],

    cerrado: false,
    saldoAnteriorPesos: 0,
    saldoAnteriorDolares: 0,
    importeConsumosPesos: 0,
    importeConsumosDolares: 0,
    importeGastosPesos: 0,
    importeGastosDolares: 0,
    importeTotalPesos: 0,
    importeTotalDolares: 0,
    saldoPendientePesos: 0,
    saldoPendienteDolares: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, params) {
        state.tarjetaId = params.tarjetaId;
        state.tarjetaResumenId = params.tarjetaResumenId;

        state.banco = '';
        state.tarjetaMarca = '';
        state.numeroCuenta = '';
        state.fechaCierre = '1900-01-01';
        state.fechaVencimiento = '1900-01-01';
        state.totalPlasticosPesos = 0;
        state.totalPlasticosDolares = 0;

        state.plasticos = [];

        state.cerrado = false;
        state.saldoAnteriorPesos = 0;
        state.saldoAnteriorDolares = 0;
        state.importeConsumosPesos = 0;
        state.importeConsumosDolares = 0;
        state.importeGastosPesos = 0;
        state.importeGastosDolares = 0;
        state.importeTotalPesos = 0;
        state.importeTotalDolares = 0;
        state.saldoPendientePesos = 0;
        state.saldoPendienteDolares = 0;
    },
    'SET_TARJETA_RESUMEN' (state, tarjetaResumen) {
        state.banco = tarjetaResumen.banco;
        state.tarjetaMarca = tarjetaResumen.tarjetaMarca;
        state.numeroCuenta = tarjetaResumen.numeroCuenta;
        state.fechaCierre = moment(tarjetaResumen.fechaCierre).format('YYYY-MM-DD');
        state.fechaVencimiento = moment(tarjetaResumen.fechaVencimiento).format('YYYY-MM-DD');

        state.plasticos = tarjetaResumen.plasticos;
        state.totalPlasticos = 0;
        state.plasticos.forEach(plastico => {
            let totalPlasticoPesos = plastico.cuotas
                .reduce((total, cuota) => total + cuota.importeCuotaPesos, 0);

            let totalPlasticoDolares = plastico.cuotas
                .reduce((total, cuota) => total + cuota.importeCuotaDolares, 0);

            plastico.totalesCuotas = [
                {
                    titulo: 'Totales',
                    totalPesos: totalPlasticoPesos,
                    totalDolares: totalPlasticoDolares    
                }
            ]
            
            state.totalPlasticosPesos += totalPlasticoPesos;
            state.totalPlasticosDolares += totalPlasticoDolares;
        });

        state.cerrado = (/true/i).test(tarjetaResumen.cerrado);
        state.saldoAnteriorPesos = parseFloat(tarjetaResumen.saldoAnteriorPesos);
        state.saldoAnteriorDolares = parseFloat(tarjetaResumen.saldoAnteriorDolares);
        state.importeConsumosPesos = parseFloat(tarjetaResumen.importeConsumosPesos);
        state.importeGastosPesos = parseFloat(tarjetaResumen.importeGastosPesos);
        state.importeTotalPesos = parseFloat(tarjetaResumen.importeConsumosPesos) 
            + parseFloat(tarjetaResumen.importeGastosPesos);
        state.importeConsumosDolares = parseFloat(tarjetaResumen.importeConsumosDolares);
        state.importeGastosDolares = parseFloat(tarjetaResumen.importeGastosDolares);
        state.importeTotalDolares = parseFloat(tarjetaResumen.importeConsumosDolares) 
            + parseFloat(tarjetaResumen.importeGastosDolares);
        state.saldoPendientePesos = parseFloat(tarjetaResumen.saldoPendientePesos);
        state.saldoPendienteDolares = parseFloat(tarjetaResumen.saldoPendienteDolares);
    },
};

const getters = {
    getField,
};

const actions = {
    getTarjetaResumen ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', params);

            let url = `tarjetasresumenes/tarjeta/${params.tarjetaId}/no-resumen`;
            
            if (params.tarjetaResumenId != 0) {
                url = `tarjetasresumenes/${params.tarjetaResumenId}/vencimiento`;
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_TARJETA_RESUMEN', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}